// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-core-navigation_modal {
  height: 90vh;
  width: 1024px;
  overflow: hidden;
}
.dl-core-navigation_aside {
  width: 100%;
  height: 100%;
}
.dl-core-navigation_modal, .dl-core-navigation_aside {
  display: flex;
}
.dl-core-navigation_modal .dl-core-navigation__entries, .dl-core-navigation_aside .dl-core-navigation__entries {
  padding-top: 0;
}
.dl-core-navigation_modal .dl-core-navigation__entries-header, .dl-core-navigation_aside .dl-core-navigation__entries-header {
  padding-top: 5px;
  padding-bottom: 7px;
}
.dl-core-navigation_modal .dl-core-navigation__search, .dl-core-navigation_aside .dl-core-navigation__search {
  max-width: 400px;
}
.dl-core-navigation_modal .dl-core-navigation__header, .dl-core-navigation_aside .dl-core-navigation__header {
  flex-basis: 64px;
  padding-top: 8px;
}
.dl-core-navigation_modal .dl-core-navigation__sidebar, .dl-core-navigation_aside .dl-core-navigation__sidebar {
  padding-top: 8px;
}
.dl-core-navigation_modal .dl-core-navigation__header {
  padding-right: 56px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/Navigation/Core/NavigationModal.scss"],"names":[],"mappings":"AAGI;EACI,YAAA;EACA,aAAA;EACA,gBAAA;AAFR;AAKI;EACI,WAAA;EACA,YAAA;AAHR;AAMI;EAEI,aAAA;AALR;AAOQ;EACI,cAAA;AALZ;AAQQ;EACI,gBAAA;EACA,mBAAA;AANZ;AASQ;EACI,gBAAA;AAPZ;AAUQ;EACI,gBAAA;EACA,gBAAA;AARZ;AAWQ;EACI,gBAAA;AATZ;AAcQ;EACI,mBAAA;AAZZ","sourcesContent":[".dl-core-navigation_modal {\n  height: 90vh;\n  width: 1024px;\n  overflow: hidden;\n}\n.dl-core-navigation_aside {\n  width: 100%;\n  height: 100%;\n}\n.dl-core-navigation_modal, .dl-core-navigation_aside {\n  display: flex;\n}\n.dl-core-navigation_modal .dl-core-navigation__entries, .dl-core-navigation_aside .dl-core-navigation__entries {\n  padding-top: 0;\n}\n.dl-core-navigation_modal .dl-core-navigation__entries-header, .dl-core-navigation_aside .dl-core-navigation__entries-header {\n  padding-top: 5px;\n  padding-bottom: 7px;\n}\n.dl-core-navigation_modal .dl-core-navigation__search, .dl-core-navigation_aside .dl-core-navigation__search {\n  max-width: 400px;\n}\n.dl-core-navigation_modal .dl-core-navigation__header, .dl-core-navigation_aside .dl-core-navigation__header {\n  flex-basis: 64px;\n  padding-top: 8px;\n}\n.dl-core-navigation_modal .dl-core-navigation__sidebar, .dl-core-navigation_aside .dl-core-navigation__sidebar {\n  padding-top: 8px;\n}\n.dl-core-navigation_modal .dl-core-navigation__header {\n  padding-right: 56px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
